import { map, toArray } from "lodash";
import { UPDATE_CART_PLANS } from "QuotePage/Actions";

import { SET_IS_LOADING_PLANS, RECEIVE_PLANS, RECEIVE_PRICING } from "./Actions";
import { mergePlans } from "./Utils";

export function loadingPlans(state = true, action) {
  switch (action.type) {
    case SET_IS_LOADING_PLANS:
      return action.isLoading;

    default:
      return state;
  }
}
export function allPlans(state = [], action) {
  switch (action.type) {
    case RECEIVE_PLANS:
      return mergePlans(state, action.plans);

    case UPDATE_CART_PLANS:
      return mergePlans(state, action.plans.medical.results);

    case RECEIVE_PRICING:
      var newPlans = map(state, (plan) => {
        let newPlan = plan;

        if (action.averageMonthlyPremiums[plan.id]) {
          newPlan = {
            ...plan,
            prices_loading: false,
            average_monthly_premium_per_person: parseInt(action.averageMonthlyPremiums[plan.id][3].toFixed(2), 10),
            average_monthly_premium: parseInt(action.averageMonthlyPremiums[plan.id][0].toFixed(2), 10),
            employee_costs: toArray(action.employeeCosts[plan.id]),
            total_cost: parseInt(action.totalCosts[plan.id].toFixed(2), 10),
          };
        }

        return newPlan;
      });
      return newPlans;

    default:
      return state;
  }
}
